import { BillingPeriod } from '@/gql/generated';

const getBillingPeriodShortCopy = (billingPeriod: BillingPeriod) => {
  switch (billingPeriod) {
    case BillingPeriod.ThreeYears:
      return '3yrs';
    case BillingPeriod.TwoYears:
      return '2yrs';
    case BillingPeriod.Year:
      return 'yr';
    case BillingPeriod.NineMonths:
      return '9mos';
    case BillingPeriod.HalfYear:
      return '½yr';
    case BillingPeriod.Quarter:
      return 'qtr';
    case BillingPeriod.Month:
      return 'mo';
    // no default
  }

  return '';
};

export default getBillingPeriodShortCopy;
